//   li: 0.7,
//   sm: 0.6,
//   kn: 0.6,
//   sc: 0.6,
//   vc
//   mv
//   ps
//   tv
//   mh

export const weights = {
  CH: 0.9,
  NO: 0.9,
  IS: 0.9,
  HK: 0.9,
  AU: 0.9,
  DK: 0.9,
  SE: 0.9,
  IE: 0.9,
  DE: 0.9,
  NL: 0.9,
  FI: 0.9,
  SG: 0.9,
  BE: 0.9,
  NZ: 0.9,
  CA: 0.9,
  LU: 0.9,
  GB: 0.9,
  JP: 0.9,
  KR: 0.9,
  KP: 0.9,
  US: 0.9,
  IL: 0.9,
  AT: 0.9,
  ES: 0.9,
  FR: 0.9,
  CY: 0.9,
  IT: 0.9,
  CZ: 0.9,
  GR: 0.9,
  PL: 0.9,
  PT: 0.9,
  CL: 0.9,
  HU: 0.9,
  AR: 0.9,
  RU: 0.9,
  CN: 0.9,
  CU: 0.9,
  PE: 0.9,
  MX: 0.9,
  BR: 0.9,
  ZA: 0.9,
  IN: 0.9,

  AE: 0.8,
  EE: 0.8,
  SA: 0.8,
  HR: 0.8,
  CO: 0.8,
  EG: 0.8,
  JM: 0.8,
  ID: 0.8,
  VN: 0.8,

  MT: 0.7,
  SI: 0.7,
  LT: 0.7,
  LV: 0.7,
  SK: 0.7,
  DO: 0.7,
  DZ: 0.7,
  EC: 0.7,
  MN: 0.7,
  PH: 0.5,
  BO: 0.5,
  VE: 0.5,
  NP: 0.5,
  MG: 0.5,
  AF: 0.5,

  AD: 0.6,
  QA: 0.6,
  RO: 0.6,
  IR: 0.6,
  UA: 0.6,
  AM: 0.6,
  SR: 0.6,
  LY: 0.6,
  PY: 0.6,
  LB: 0.6,
  BW: 0.6,
  MA: 0.6,
  SV: 0.6,
  NI: 0.6,
  BD: 0.6,
  SY: 0.6,
  CD: 0.6,
  HT: 0.6,
  'CN-TW': 0.6,
  VA: 0.6,

  OM: 0.5,
  BS: 0.5,
  KZ: 0.5,
  TT: 0.5,
  CR: 0.5,
  UY: 0.5,
  BY: 0.5,
  PA: 0.5,
  MY: 0.5,
  GE: 0.5,
  RS: 0.5,
  TH: 0.5,
  AL: 0.5,
  BG: 0.5,
  LK: 0.5,
  MD: 0.5,
  AZ: 0.5,
  TN: 0.5,
  UZ: 0.5,
  DM: 0.5,
  IQ: 0.5,
  CV: 0.5,
  GH: 0.5,
  MM: 0.5,
  KE: 0.5,
  PG: 0.5,
  PK: 0.5,
  NG: 0.5,
  SD: 0.5,
  BH: 0.5,

  BZ: 0.4,
  BB: 0.4,
  BA: 0.4,
  PW: 0.4,
  FJ: 0.4,
  JO: 0.4,
  WS: 0.4,
  BT: 0.4,
  FM: 0.4,
  GT: 0.4,
  HN: 0.4,
  LA: 0.4,
  TL: 0.4,
  KH: 0.4,
  ZW: 0.4,
  AO: 0.4,
  CM: 0.4,
  ZM: 0.4,
  MR: 0.4,
  RW: 0.5,
  UG: 0.5,
  LS: 0.5,
  ET: 0.5,
  YE: 0.5,
  MZ: 0.5,

  AG: 0.3,
  MK: 0.3,
  TO: 0.3,
  TM: 0.3,
  LC: 0.3,
  GY: 0.3,
  GA: 0.3,
  KG: 0.3,
  TJ: 0.3,
  KI: 0.3,
  ST: 0.3,
  NA: 0.3,
  VU: 0.3,
  SB: 0.3,
  CI: 0.3,
  TZ: 0.3,
  MW: 0.3,
  SN: 0.3,
  DJ: 0.3,
  GM: 0.3,
  LR: 0.3,
  BF: 0.3,
  CF: 0.3,
  NE: 0.3,
  TD: 0.3,

  SZ: 0.2,
  GQ: 0.2,
  TG: 0.2,
  BJ: 0.2,
  ER: 0.2,
  GW: 0.2,
  SL: 0.2,
  GN: 0.2,
  ML: 0.2,
  BI: 0.2,
  SS: 0.2,

  FK: 0.1,
  GL: 0.1,
  CG: 0.1,
  PF: 0.1,
  SO: 0.1,
  // YT: 0.1,
  GU: 0.1,
  TR: 0.1,
  PR: 0.1,
  VI: 0.1,
  HM: 0.1,
  NC: 0.1,
  // GP: 0.1,
  // SJ: 0.1,
  // GF: 0.1,
  EH: 0.1,
  GS: 0.1,
  // TW: 0.1,
  ME: 0.1,
  // MQ: 0.1,
  FO: 0.1,
  GD: 0.1,
  // AN: 0.1,
  KW: 0.1,
  NU: 0.1,
  TF: 0.1,
  BN: 0.1,
  KY: 0.1,
  IM: 0.1,
  IO: 0.1,
  KM: 0.1,
  MU: 0.1,

  MH: 0.2,
  MP: 0.2,
  AS: 0.4,
  SH: 0.3,
  PN: 0.2,
  AI: 0.3,
  BM: 0.5,
  VG: 0.4,
  TC: 0.4,
  MS: 0.3,
  JE: 0.3,
  GG: 0.3,
  SC: 0.2,
  SM: 0.4,
  VC: 0.2,
  KN: 0.1,
  CK: 0.2,
  AW: 0.2,
  CW: 0.2,
  NR: 0.2,
  MC: 0.8,
  MV: 0.5,
  LI: 0.6,
  PS: 0.8,
  PM: 0.7,
  WF: 0.2,
  MF: 0.2,
  BL: 0.2,
  AX: 0.2,
  MO: 0.3,
  NF: 0.3,
  AQ: 0.9,
  SX: 0.2,
};

export function weightedShuffle<T extends readonly [string, number]>(
  array: T[],
  random: () => number = Math.random,
) {
  const arr = [...array];
  const newWeights = arr.map(([key, value]) => [
    key,
    Math.pow(random(), 1 / value),
  ] as const);
  newWeights.sort((a, b) => {
    return a[1] < b[1] ? 1 : -1;
  });
  return newWeights;
}
